import $ from 'jquery'

document.addEventListener('turbo:load', () => {
  $(function () {
    $('body').tooltip({ selector: '[data-toggle=tooltip]' })
  })
})
